/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Price_Page_How_LeadInputs */

const en_price_page_how_lead = /** @type {(inputs: Price_Page_How_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Right when you book,`)
};

const pl_price_page_how_lead = /** @type {(inputs: Price_Page_How_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prosto przy rezerwacji,`)
};

/**
* | output |
* | --- |
* | "Right when you book," |
*
* @param {Price_Page_How_LeadInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const price_page_how_lead = /** @type {((inputs?: Price_Page_How_LeadInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Price_Page_How_LeadInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_price_page_how_lead(inputs)
	return en_price_page_how_lead(inputs)
});